import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { HrSurvey, RepositoryModal } from '../../../shared'

@Component({
    templateUrl: './hr-survey.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class HrSurveyComponent extends RepositoryModal<HrSurvey> {}
